// extracted by mini-css-extract-plugin
module.exports = {"dashboardSelectArea":"DashboardSelectArea_dashboardSelectArea__17YrZ","selectItem":"DashboardSelectArea_selectItem__1uz3E","buttonApply":"DashboardSelectArea_buttonApply__zRuJC"};